/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { DataService } from 'app/shared/services/data.service';
import { Injectable } from '@angular/core';
import { ApiEntity } from 'app/api/models/api-entity.model';
import { ApiResponseSummary } from 'app/shared/models/api-info.model';
@Injectable({providedIn: 'root'})
export class CustomerFormService extends DataService<any> {


  constructor(apiDependencies: ApiDependenciesService) {
    super(apiDependencies);
  }


//#region endpoints
  updateBasketCustomerFormEndpoint(itemId: number): string{
	return '/basket-customers' + '/' + itemId;
  }
  getBasketCustomerFormEndpoint(itemId: number): string{
	return '/basket-customers' + '/' + itemId;
  }
//#endregion

  async updateBasketCustomerForm(itemId: number, dataToUpdate: any): Promise<ApiResponseSummary<any>> {
	return this.updateItem(itemId, dataToUpdate, this.updateBasketCustomerFormEndpoint(itemId));
  }

  async getBasketCustomerForm(itemId: number): Promise<ApiEntity> {
    let model: ApiEntity;
    await this
	  .setEndpoint(this.getBasketCustomerFormEndpoint(itemId))
      .getSingle().then((response: any) => {
        model = response;
      });
    return Promise.resolve(model);
  }
  async getSingleItem(itemId: number, dataToUpdate: any, endpoint: string) {

    console.log(endpoint);
    await this
      .setEndpoint(endpoint)
      .getSingle()
      .then((response) => {
      });
    
  }

  async updateItem(itemId: number, dataToUpdate: any, endpoint: string): Promise<ApiResponseSummary<any>> {
    let result: ApiResponseSummary<any>;

    await this
      .setEndpoint(endpoint)
      .update(dataToUpdate)
      .then(response => {
        result = response;
        if (result.success === true) {

        }
      });
      return Promise.resolve(result);
    
  }

  async saveItem(dataToUpdate: any, endpoint: string): Promise<ApiResponseSummary<any>> {
    let result: ApiResponseSummary<any>;
    await this
      .setEndpoint(endpoint)
      .save(dataToUpdate)
      .then(response => {
        result = response;
        if (result.success === true) {

        }
      });
      return Promise.resolve(result);
  }

}
